import { render, staticRenderFns } from "./activity-booth-mall.vue?vue&type=template&id=dce964f0&scoped=true&"
import script from "./activity-booth-mall.vue?vue&type=script&lang=js&"
export * from "./activity-booth-mall.vue?vue&type=script&lang=js&"
import style0 from "./activity-booth-mall.vue?vue&type=style&index=0&id=dce964f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce964f0",
  null
  
)

export default component.exports